import { render, staticRenderFns } from "./VCardMapDetail.vue?vue&type=template&id=410e937c"
import script from "./VCardMapDetail.vue?vue&type=script&lang=js"
export * from "./VCardMapDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports